import React from 'react';
import image from '../assets/images/logo-anz.svg';
function Banner(props){
  return (
        <nav class="navbar banner float-start" style={{backgroundColor:"#004165", marginBottom:0,borderRadius: 0}}>
          {/* <div class="container" > */}
             <div className="container" style={{display:'inline'}}>
                  <a href="https://www.anz.co.nz/personal/" className="logo logo--authored " title="ANZ Logo"><img src={image} alt="ANZ logo"/></a>
              </div>
        </nav>

  )
}

export default Banner;
